/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { _PAGE_SIZE_ } from "../../../../../middlewares/other/tools";
import { useBaseLevelContext } from "../../../../../context/levels/BaseLevelContext";
import {
  pushAddLevel,
  pushEditLevel,
  pushSingleLevelDashboard,
} from "../../../../../middlewares/sysNavigation/SysNavigation";
import {
  MyButton,
  MySearch,
  Pagination,
} from "../../../component/Component";

const Tabs = [
  { title: "First", route: "/levels/first", value: "first" },
  { title: "Second", route: "/levels/second", value: "second" },
  { title: "Third", route: "/levels/third", value: "third" },
  { title: "Fourth", route: "/levels/fourth", value: "fourth" },
];

const addRoute = "/level/add";
const editRoute = "/level/edit";
const contentRoute = "/dosee/data";
const dashboardRoute = "/level/dashboard";

const Overview = () => {
  const navigate = useNavigate();
  const [localLevels, setLocalLevels] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("first");
  const { fetchLevels, allLevels, count, setTemporaryLevelName, setAllLevels } =
    useBaseLevelContext();

  const [page, setPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (searchKey === "") {
      if (allLevels) setLocalLevels(allLevels);
      else fetchLevels({ page: 1, pageSize: 50, level: selectedLevel });
    }
  }, [allLevels]);

  const search = (key) => {
    if (key === "") {
      setLocalLevels(allLevels);
      setSearchKey("");
    } else if (allLevels) {
      const needle = key.toLowerCase();
      setLocalLevels(allLevels.filter((i) => String(i?.name).toLowerCase().includes(needle)));
    }
  };

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50 w-full">
      <div className="mx-auto max-w-7xl space-y-4">
        {/* Header */}
        <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-sm font-semibold tracking-tight text-gray-900">
                Administrative Levels
              </h1>
              <p className="mt-1 text-[11px] text-gray-600">
                A tidy overview of First–Fourth levels. Use the Manage menu for actions.
              </p>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <MySearch
                showGlobalSearch={false}
                onChange={(e) => {
                  setSearchKey(e.target.value);
                  search(e.target.value);
                }}
              />
              <Link to={addRoute}>
                <MyButton
                  title={`Add ${selectedLevel.charAt(0).toUpperCase() + selectedLevel.slice(1)} Level`}
                  className="bg-gray-900 hover:bg-gray-800 min-w-fit"
                  onClick={() => {
                    pushAddLevel(selectedLevel);
                    setTemporaryLevelName(selectedLevel);
                  }}
                />
              </Link>
            </div>
          </div>

          {/* Segmented tabs */}
          <div className="mt-4 overflow-x-auto">
            <div className="inline-flex rounded-xl border border-gray-200 bg-gray-50 p-1">
              {Tabs.map((tab) => {
                const active = selectedLevel === tab.value;
                return (
                  <Link
                    key={tab.value}
                    to={tab.route}
                    onClick={() => {
                      setSelectedLevel(tab.value);
                      setAllLevels(null);
                      setLocalLevels(null);
                      setSearchKey("");
                    }}
                    className={[
                      "px-4 py-1.5 text-xs font-semibold rounded-lg capitalize transition",
                      active
                        ? "bg-white text-gray-900 shadow-sm"
                        : "text-gray-600 hover:text-gray-900 hover:bg-white",
                    ].join(" ")}
                  >
                    {tab.title}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="relative overflow-x-auto">
            <table className="w-full text-left text-xs">
              <thead className="sticky top-0 z-10 bg-gray-50/90 backdrop-blur-sm">
                <tr className="text-gray-700">
                  <th className="px-4 py-3 font-semibold w-2/3 border-b border-gray-200">
                    Name
                  </th>
                  <th className="px-4 py-3 font-semibold w-1/3 text-center border-b border-gray-200">
                    Manage
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {localLevels ? (
                  localLevels.length > 0 ? (
                    localLevels.map((item, idx) => {
                      const item_id =
                        selectedLevel === "first"
                          ? item?.first_level_id
                          : selectedLevel === "second"
                            ? item?.second_level_id
                            : selectedLevel === "third"
                              ? item?.third_level_id
                              : item?.fourth_level_id;

                      return (
                        <tr key={idx} className="hover:bg-gray-50/60 transition-colors">
                          <td className="px-4 py-3">
                            <span className="font-medium text-gray-900">{item?.name}</span>
                          </td>
                          <td className="px-4 py-3">
                            <RowManage
                              item={item}
                              item_id={item_id}
                              currentLevel={selectedLevel}
                              navigate={navigate}
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={2} className="px-4 py-8 text-center text-gray-600">
                        No levels found for this tab.
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td className="px-4 py-3">...</td>
                    <td className="px-4 py-3 text-center">...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={count}
          callbackFunction={(_p, _pSize) => {
            fetchLevels({
              page: _p,
              pageSize: _pSize,
              level: selectedLevel,
            });
          }}
        />
      </div>
    </div>
  );
};

/** ---------- Manage per row (menu + confirms) ---------- */
const RowManage = ({ item, item_id, currentLevel, navigate }) => {
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState({
    open: false,
    title: "",
    desc: "",
    confirmLabel: "Confirm",
    onConfirm: null,
  });

  const { deleteOne, fetchLevels, setTemporaryLevel } = useBaseLevelContext();

  useEffect(() => {
    const onClickOutside = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const ask = (title, desc, onConfirm, confirmLabel = "Confirm") =>
    setConfirm({ open: true, title, desc, onConfirm, confirmLabel });

  const goDashboard = () =>
    ask(
      "Open dashboard?",
      `Open dashboard for “${item?.name}”?`,
      () => {
        navigate(dashboardRoute);
        pushSingleLevelDashboard({ data: item, level: currentLevel });
      },
      "Open"
    );

  const goContent = () =>
    ask(
      "Continue to Content?",
      `Go to content for “${item?.name}”?`,
      () => {
        navigate(contentRoute);
        pushAddLevel(currentLevel);
        setTemporaryLevel({ ...item, currentLevel });
      },
      "Continue"
    );

  const goEdit = () =>
    ask(
      "Edit this level?",
      `Edit “${item?.name}”?`,
      () => {
        navigate(editRoute);
        pushAddLevel(currentLevel);
        pushEditLevel({ ...item });
        setTemporaryLevel({ ...item, currentLevel });
      },
      "Edit"
    );

  const doDelete = () =>
    ask(
      "Delete this level?",
      `This action cannot be undone. Delete “${item?.name}”?`,
      async () => {
        const { status } = await deleteOne({ level_id: item_id, level: currentLevel });
        if (status === 200) {
          // Refresh list after deletion
          await fetchLevels({ page: 1, pageSize: 50, level: currentLevel });
        }
      },
      "Delete"
    );

  return (
    <>
      {/* Manage trigger */}
      <div className="relative flex justify-center" ref={menuRef}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-800 shadow-sm hover:bg-gray-50"
        >
          Manage
          <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.206l3.71-3.975a.75.75 0 111.08 1.04l-4.24 4.54a.75.75 0 01-1.08 0l-4.24-4.54a.75.75 0 01.02-1.06z" />
          </svg>
        </button>

        {/* Menu */}
        {open && (
          <div className="absolute right-0 z-20 mt-2 w-44 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg">
            <MenuItem label="Dashboard" onClick={() => { setOpen(false); goDashboard(); }} />
            <MenuItem label="Content" onClick={() => { setOpen(false); goContent(); }} />
            <MenuItem label="Edit" onClick={() => { setOpen(false); goEdit(); }} />
            <MenuItem danger label="Delete" onClick={() => { setOpen(false); doDelete(); }} />
          </div>
        )}
      </div>

      {/* Generic confirm modal */}
      <ConfirmModal
        open={confirm.open}
        title={confirm.title}
        description={confirm.desc}
        confirmLabel={confirm.confirmLabel}
        onClose={() => setConfirm((c) => ({ ...c, open: false }))}
        onConfirm={async () => {
          try {
            await confirm.onConfirm?.();
          } finally {
            setConfirm((c) => ({ ...c, open: false }));
          }
        }}
      />
    </>
  );
};

const MenuItem = ({ label, onClick, danger }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "flex w-full items-center justify-between px-3 py-2 text-left text-xs transition",
      danger
        ? "text-red-700 hover:bg-red-50"
        : "text-gray-800 hover:bg-gray-50",
    ].join(" ")}
  >
    <span>{label}</span>
    <svg
      className="h-3.5 w-3.5 opacity-60"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414L12.414 10l-3.707 3.707a1 1 0 01-1.414 0z" />
    </svg>
  </button>
);

/** Minimal, reusable confirmation modal */
const ConfirmModal = ({ open, title, description, confirmLabel = "Confirm", onConfirm, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/30" />
      <div
        className="relative w-full max-w-sm rounded-2xl border border-gray-200 bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-5">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          <p className="mt-1.5 text-[12px] text-gray-600">{description}</p>
          <div className="mt-4 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-800 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex items-center justify-center rounded-lg bg-gray-900 px-4 py-2 text-xs font-semibold text-white hover:bg-gray-800"
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
